module.exports = __webpack_public_path__ + "static/media/screen3.b3e3ca4e.png";